





































import Vue from "vue";
import semver from "semver";

// Components
import InstallationUpdatesStatusCard from "@/components/Cards/Model/InstallationUpdatesStatusCard.vue";
import MachineStatusAndUpdatesCard from "@/components/Cards/Model/MachineStatusAndUpdatesCard.vue";

// Model
import { MODULE_COLORS } from "@/utility/Constants";

export default Vue.extend({
    components: {
        InstallationUpdatesStatusCard,
        MachineStatusAndUpdatesCard,
    },
    data() {
        return { MODULE_COLORS };
    },
    props: ["installation", "installationStatus", "installationUpdate", "loading"],
    computed: {
        hasAgent() {
            try {
                if (this.installation && this.installation.agentInfo && this.installation.agentInfo.version) {
                    let splittedVersion = this.installation.agentInfo.version.split(".");
                    if (splittedVersion && splittedVersion.length >= 3) return semver.gte(`${splittedVersion[0]}.${splittedVersion[1]}.${splittedVersion[2]}`, "7.1.0");
                }
            } catch {
                console.error("Cannot parse agent version");
            }
            return false;
        },
    },
});
